import React from 'react';
import PropTypes from 'prop-types';
import { flowRight as compose } from 'lodash';
import { gql } from '@apollo/client';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import { Grid, Row, Col } from 'react-bootstrap';

// Components
import Trust from '../../components/Trust';
import Loader from '../../components/Loader';
import DashboardSideMenu from '../../components/Dashboard/DashboardSideMenu';

import { withQuery } from '../../hoc/withGraphql';

import cs from '../../components/commonStyle.css';
import s from './TrustAndVerification.css';

const TrustAndVerification = (props) => {

  const { data: { loading, getUserVerifiedInfo }, title } = props;
  return (
    <Grid fluid className={'listingContainer'}>
      <Row>
        <Col xs={12} sm={12} md={4} lg={4} className={cs.spaceTop6}>
          <DashboardSideMenu isTrustVerfiedPage />
        </Col>
        <Col xs={12} sm={12} md={8} lg={8} className={cs.spaceTop6}>
          {
            loading && <Loader type={"text"} />
          }
          {
            !loading && <Trust data={getUserVerifiedInfo} />
          }
        </Col>
      </Row>
    </Grid>
  );
}

TrustAndVerification.propTypes = {
  title: PropTypes.string.isRequired,
  data: PropTypes.shape({
    loading: PropTypes.bool,
    getUserVerifiedInfo: PropTypes.object,
  }),
  account: PropTypes.shape({
    userId: PropTypes.string.isRequired,
  }).isRequired
};

TrustAndVerification.defaultProps = {
  data: {
    loading: true
  }
};

const mapState = (state) => ({
  account: state.account.data
});

const mapDispatch = {};

export default compose(
  withStyles(cs, s),
  connect(mapState, mapDispatch),
  withQuery(gql`
        query ($userId: String!) {
          getUserVerifiedInfo (userId: $userId) {
            id
            isEmailConfirmed
            isFacebookConnected
            isGoogleConnected
            isIdVerification
            status
          }
        }
      `,
    {
      options: (props) => ({
        variables: {
          userId: props.account.userId,
        },
        ssr: false,
      })
    }
  ),
)(TrustAndVerification);